import { Home, Search, Clock, Menu, Moon, Sun, Star } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import { cn } from "@/lib/utils";
import { useAuth } from "@/hooks/useAuth";
import { useTheme } from "next-themes";

interface MobileBottomNavProps {
  onMenuClick?: () => void;
}

const MobileBottomNav = ({ onMenuClick }: MobileBottomNavProps) => {
  const location = useLocation();
  const { user, isAdmin } = useAuth();
  const { theme, setTheme } = useTheme();

  const navItems = [
    {
      icon: Home,
      label: "Accueil",
      path: "/",
    },
    {
      icon: Search,
      label: "Recherche",
      path: "/#search",
      onClick: () => {
        const searchInput = document.querySelector('input[type="search"]') as HTMLInputElement;
        searchInput?.focus();
      },
    },
    ...(user && !isAdmin ? [{
      icon: Star,
      label: "Favoris",
      path: "/dashboard",
    }] : []),
    {
      icon: Clock,
      label: "Historique",
      path: "/#history",
      onClick: () => {
        const searchInput = document.querySelector('input[type="search"]') as HTMLInputElement;
        searchInput?.focus();
      },
    },
  ];

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-40 bg-background/60 md:bg-background/70 backdrop-blur-md md:backdrop-blur-xl border-t border-border/50 shadow-lg">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-around h-16 md:h-20 px-2 md:px-8">
        {navItems.map((item) => {
          const isActive = location.pathname === item.path;
          const Icon = item.icon;
          
          return (
            <Link
              key={item.path}
              to={item.path}
              onClick={item.onClick}
              className={cn(
                "relative flex flex-col items-center justify-center gap-1 md:gap-2 px-3 md:px-6 py-2 md:py-3 rounded-lg transition-all duration-300",
                "hover-scale active:scale-95",
                isActive
                  ? "text-primary bg-primary/10 md:bg-primary/15 before:absolute before:top-0 before:left-1/2 before:-translate-x-1/2 before:w-12 md:before:w-16 before:h-1 before:bg-primary before:rounded-b-full before:transition-all before:duration-500 before:ease-out"
                  : "text-muted-foreground hover:text-foreground hover:bg-accent/5"
              )}
            >
              <Icon className={cn("h-5 w-5 md:h-6 md:w-6 transition-all duration-300", isActive && "animate-scale-in")} />
              <span className={cn("text-xs md:text-sm transition-all duration-300", isActive ? "font-bold" : "font-medium")}>{item.label}</span>
            </Link>
          );
        })}
        
        {/* Theme toggle button */}
        <button
          onClick={() => setTheme(theme === "dark" ? "light" : "dark")}
          className={cn(
            "flex flex-col items-center justify-center gap-1 md:gap-2 px-3 md:px-6 py-2 md:py-3 rounded-lg transition-all duration-300",
            "hover-scale active:scale-95",
            "text-muted-foreground hover:text-foreground hover:bg-accent/5"
          )}
        >
          {theme === "dark" ? (
            <Sun className="h-5 w-5 md:h-6 md:w-6 transition-transform duration-300" />
          ) : (
            <Moon className="h-5 w-5 md:h-6 md:w-6 transition-transform duration-300" />
          )}
          <span className="text-xs md:text-sm font-medium transition-all duration-300">Thème</span>
        </button>
        
        {/* Menu button */}
        <button
          onClick={onMenuClick}
          className={cn(
            "flex flex-col items-center justify-center gap-1 md:gap-2 px-3 md:px-6 py-2 md:py-3 rounded-lg transition-all duration-300",
            "hover-scale active:scale-95",
            "text-muted-foreground hover:text-foreground hover:bg-accent/5"
          )}
        >
          <Menu className="h-5 w-5 md:h-6 md:w-6 transition-transform duration-300" />
          <span className="text-xs md:text-sm font-medium transition-all duration-300">Menu</span>
        </button>
        </div>
      </div>
    </nav>
  );
};

export default MobileBottomNav;
